/* LEHM·COSMETICS Theme JS — lean, no dependencies */
'use strict';

const LEHM = {
  _toastTimer: null,

  init() {
    this.nav();
    this.cart();
    this.search();
    this.productPage();
    this.filterTabs();
    this.glowForm();
    this.newsletter();
    this.faq();
    this.overlay();
    this.loadCart();
  },

  // ── NAV ──
  nav() {
    const ham = document.getElementById('ham');
    const mob = document.getElementById('mob-nav');
    const x   = document.getElementById('mob-x');
    if (ham) ham.addEventListener('click', () => { mob.classList.add('on'); this.openOverlay(); document.body.style.overflow='hidden'; });
    if (x)   x.addEventListener('click',   () => { mob.classList.remove('on'); this.closeOverlay(); document.body.style.overflow=''; });
  },

  // ── OVERLAY ──
  overlay() {
    document.getElementById('overlay')?.addEventListener('click', () => {
      document.getElementById('mob-nav')?.classList.remove('on');
      document.getElementById('cart-drawer')?.classList.remove('on');
      document.getElementById('search-modal')?.classList.remove('on');
      this.closeOverlay();
      document.body.style.overflow = '';
    });
  },
  openOverlay()  { document.getElementById('overlay')?.classList.add('on'); },
  closeOverlay() { document.getElementById('overlay')?.classList.remove('on'); },

  // ── CART ──
  cart() {
    document.getElementById('cart-open')?.addEventListener('click',  () => this.openCart());
    document.getElementById('cart-x')?.addEventListener('click',     () => this.closeCart());
    document.getElementById('cart-keep')?.addEventListener('click',  () => this.closeCart());
  },
  openCart() {
    document.getElementById('cart-drawer')?.classList.add('on');
    this.openOverlay();
    document.body.style.overflow = 'hidden';
  },
  closeCart() {
    document.getElementById('cart-drawer')?.classList.remove('on');
    this.closeOverlay();
    document.body.style.overflow = '';
  },

  async loadCart() {
    try {
      const r = await fetch('/cart.js');
      if (!r.ok) return;
      const c = await r.json();
      this.renderCart(c);
    } catch(e) {}
  },

  async addToCart(variantId, qty = 1) {
    const btn = document.getElementById('add-to-cart');
    const orig = btn?.textContent;
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({id: variantId, quantity: qty})
      });
      const item = await r.json();
      if (item.status === 422) { this.toast('Out of stock'); return; }
      const cart = await (await fetch('/cart.js')).json();
      this.renderCart(cart);
      this.openCart();
      this.toast(`${item.title.substring(0,32)} added ✓`);
      if (btn) { btn.textContent = 'Added ✓'; btn.classList.add('added'); setTimeout(() => { btn.textContent = orig; btn.classList.remove('added'); btn.disabled = false; }, 2000); }
    } catch(e) {
      this.toast('Could not add item');
      if (btn) { btn.textContent = orig; btn.disabled = false; }
    }
  },

  async changeQty(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({id: key, quantity: qty})
      });
      const cart = await (await fetch('/cart.js')).json();
      this.renderCart(cart);
    } catch(e) {}
  },

  renderCart(cart) {
    const body = document.getElementById('cart-body');
    const foot = document.getElementById('cart-foot');
    const total = document.getElementById('cart-total');
    const pip   = document.getElementById('cart-pip');
    if (!body) return;
    if (pip) pip.classList.toggle('on', (cart.item_count || 0) > 0);
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = `<div class="cart-nil"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity=".2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Your bag is empty</p></div>`;
      if (foot) foot.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(i => `
      <div class="cline">
        <div class="cimg"><img src="${i.image||''}" alt="${i.title||''}" loading="lazy" width="70" height="78"></div>
        <div>
          <p class="cname">${i.product_title||''}</p>
          <p class="ccat">${i.vendor||''}</p>
          <div class="cfoot">
            <div class="qrow">
              <button class="qbtn" onclick="LEHM.changeQty('${i.key}',${i.quantity-1})" aria-label="Less">−</button>
              <span class="qnum">${i.quantity}</span>
              <button class="qbtn" onclick="LEHM.changeQty('${i.key}',${i.quantity+1})" aria-label="More">+</button>
            </div>
            <span class="cprice">£${(i.line_price/100).toFixed(2)}</span>
          </div>
          <button class="crm" onclick="LEHM.changeQty('${i.key}',0)">Remove</button>
        </div>
      </div>`).join('');
    if (total) total.textContent = '£' + (cart.total_price/100).toFixed(2);
    if (foot) foot.style.display = 'block';
  },

  // ── SEARCH ──
  search() {
    document.getElementById('search-open')?.addEventListener('click',  () => this.openSearch());
    document.getElementById('search-x')?.addEventListener('click',     () => this.closeSearch());
    const inp = document.getElementById('search-input');
    inp?.addEventListener('keydown', e => {
      if (e.key === 'Enter' && inp.value.trim()) window.location = `/search?q=${encodeURIComponent(inp.value.trim())}`;
      if (e.key === 'Escape') this.closeSearch();
    });
  },
  openSearch() {
    document.getElementById('search-modal')?.classList.add('on');
    this.openOverlay();
    setTimeout(() => document.getElementById('search-input')?.focus(), 100);
  },
  closeSearch() {
    document.getElementById('search-modal')?.classList.remove('on');
    this.closeOverlay();
  },

  // ── PRODUCT PAGE ──
  bindGalleryThumbs() {
    document.querySelectorAll('.thumb').forEach((t) => {
      t.addEventListener('click', () => {
        document.querySelectorAll('.thumb').forEach(x => x.classList.remove('on'));
        t.classList.add('on');
        const img = document.getElementById('main-img');
        const src = t.dataset.fullSrc || t.querySelector('img')?.src;
        if (img && src) {
          img.srcset = t.dataset.fullSrcset || '';
          img.src = src;
        }
      });
    });
  },

  productPage() {
    // Gallery thumbs
    this.bindGalleryThumbs();

    // Qty
    document.getElementById('qty-minus')?.addEventListener('click', () => {
      const el = document.getElementById('qty-val');
      const v = parseInt(el?.textContent || 1);
      if (v > 1 && el) el.textContent = v - 1;
    });
    document.getElementById('qty-plus')?.addEventListener('click', () => {
      const el = document.getElementById('qty-val');
      if (el) el.textContent = parseInt(el.textContent || 1) + 1;
    });

    // ATC
    document.getElementById('add-to-cart')?.addEventListener('click', () => {
      const vid = document.getElementById('variant-id')?.value;
      const qty = parseInt(document.getElementById('qty-val')?.textContent || 1);
      if (vid) this.addToCart(parseInt(vid), qty);
    });

    // Buy Now
    document.getElementById('buy-now')?.addEventListener('click', async () => {
      const vid = document.getElementById('variant-id')?.value;
      const qty = parseInt(document.getElementById('qty-val')?.textContent || 1);
      if (!vid) return;
      try {
        await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:parseInt(vid), quantity:qty}) });
        window.location = '/checkout';
      } catch(e) { window.location = '/checkout'; }
    });

    // Tabs
    document.querySelectorAll('.tabbtn').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tab;
        document.querySelectorAll('.tabbtn').forEach(b => b.classList.remove('on'));
        document.querySelectorAll('.tabpane').forEach(p => p.classList.remove('on'));
        btn.classList.add('on');
        document.getElementById(`tab-${tab}`)?.classList.add('on');
      });
    });
  },

  // ── FILTER TABS ──
  filterTabs() {
    document.querySelectorAll('.ftab').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.ftab').forEach(b => { b.classList.remove('on'); b.setAttribute('aria-pressed','false'); });
        btn.classList.add('on'); btn.setAttribute('aria-pressed','true');
        const f = btn.dataset.filter;
        let vis = 0;
        document.querySelectorAll('[data-pcat]').forEach(c => {
          const show = f === 'all' || c.dataset.pcat === f;
          c.style.display = show ? '' : 'none';
          if (show) vis++;
        });
      });
    });
  },

  // ── GLOW FORM ──
  glowForm() {
    document.getElementById('waitlist-form')?.addEventListener('submit', e => {
      e.preventDefault();
      document.getElementById('waitlist-form').style.display = 'none';
      document.getElementById('wl-success').style.display = 'block';
      this.toast("You're on the Glow Box waitlist! 💚");
    });
  },

  // ── NEWSLETTER ──
  newsletter() {},

  // ── FAQ ──
  faq() {
    document.querySelectorAll('.faq-q').forEach(q => {
      q.addEventListener('click', () => {
        const item = q.closest('.faq-item');
        const open = item.classList.contains('open');
        document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
        if (!open) item.classList.add('open');
      });
    });
  },

  // ── TOAST ──
  toast(msg) {
    const t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => t.classList.remove('on'), 3200);
  }
};

document.addEventListener('DOMContentLoaded', () => LEHM.init());
